import type { UserRole } from '../types/crm';

/** Max project update previews shown in the projects list for management users. */
export const MANAGEMENT_PROJECT_UPDATE_LIMIT = 10;

/** Roles that can browse all accounts, projects, tasks, and updates (read). */
export function canViewAllRecords(role: UserRole): boolean {
  return role === 'admin' || role === 'it' || role === 'management';
}

/** @deprecated Supervisor team scope retired — always false. */
export function canViewAssignedTeam(_role: UserRole): boolean {
  return false;
}

/** Roles that can edit records they do not own (admin+ and management; supervisor only team via RLS). */
export function canElevatedWrite(role: UserRole): boolean {
  return role === 'admin' || role === 'it' || role === 'management';
}

/** Any signed-in CRM user may create accounts / own projects, tasks, and contacts (matches RLS). */
export function canCreatePersonalCrmRecords(_role: UserRole): boolean {
  return true;
}

/** IT-like browse chrome: user filter, exports, full lists. Does not grant write. */
export function hasElevatedBrowseUi(role: UserRole): boolean {
  return canViewAllRecords(role);
}

export function canApproveTransfers(role: UserRole): boolean {
  return role === 'admin' || role === 'it' || role === 'management';
}

export function canPostManagementReply(role: UserRole): boolean {
  return role === 'management';
}
